import { render, staticRenderFns } from "./FBModeredit.vue?vue&type=template&id=6cf2dc45&scoped=true"
import script from "./FBModeredit.vue?vue&type=script&lang=js"
export * from "./FBModeredit.vue?vue&type=script&lang=js"
import style0 from "./FBModeredit.vue?vue&type=style&index=0&id=6cf2dc45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf2dc45",
  null
  
)

export default component.exports